import { useDispatch, useSelector } from "react-redux";
import classes from "./questionTypes.module.css";
import { selectFormData, setFormData } from "../../../../slices/form";

const MultipleChoiceCheckbox = ({ box }) => {
  const formData = useSelector(selectFormData);
  const { questions } = formData || {};
  const { skills } = questions || {};

  const dispatch = useDispatch();
  return (
    <div className={classes.individualCheckbox}>
      <label className={classes.container}>
        <input
          name={box.name}
          type="checkbox"
          checked={skills?.[box.name] || false}
          onChange={(e) => {
            const { checked, name } = e.target;
            dispatch(
              setFormData({
                questions: {
                  ...questions,
                  skills: { ...skills, [name]: checked },
                },
              })
            );
          }}
        />
        <span className={classes.checkmark}></span>
      </label>
      <span>{box.display}</span>
    </div>
  );
};

export default MultipleChoiceCheckbox;
